export abstract class GridColumnComponent {
  type: string;
  context: any;
  config: any;
  public get configPayload(): any {
    return this.config[this.type].payload;
  }
}
